module.exports = __webpack_public_path__ + "img/stock7.1aa2c076.png";